// Hardcoded feature request data for Sentinel
export const sentinelFeatures = [
  {
    date: '2025-06-01',
    feature: 'Sentinel Guard',
    description: 'Advanced monitoring for Sentinel',
    details: 'Advanced monitoring capabilities tailored for Sentinel operations, providing enhanced oversight across accounts and strategies.',
    beta: '',
    release: '',
  },
  {
    date: '2025-04-10',
    feature: 'Multi-Account Support',
    description: 'Support for multiple Sentinel accounts',
    details: 'Enable consolidated control and monitoring across multiple Sentinel accounts.',
    beta: '2025-04-03',
    release: '2025-04-10',
  },
  {
    date: '2025-02-28',
    feature: 'Sentinel Reports',
    description: 'Automated reporting for Sentinel',
    details: 'Automated generation of operational and risk reports for Sentinel environments.',
    beta: '2025-02-21',
    release: '2025-02-28',
  },
  {
    date: '',
    feature: 'Sentinel API',
    description: 'Public API for Sentinel',
    details: 'Public API to integrate external systems with Sentinel.',
    beta: '',
    release: '',
  },
];
